import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateHealthCheckEventType extends Enum {
    static FAMILY_EVENTS: string = 'family_events';
    static PEOPLE_IN_PLAN: string = 'people_in_plan';
    static MONEY_AND_PROPERTY: string = 'money_and_property';
    static LOCATION: string = 'location';
    static BUSINESS: string = 'business';
    static ADDITIONAL_NOTES: string = 'additional_notes';
    static REVIEW: string = 'review';
    static RECOMMENDATION: string = 'recommendation';
}
